import Vue from "vue";
import CXMApiClient from "../CXMApiClient";
import { CountryCodes } from "@/lib/utilities/enums";

function initialLoad() {
  return {
    DealerSettings: [],
    PlatformInfo: [], // DO NOT USE TO POPULATE STORE DROPDOWNS
    AMDealerSettings: [],
    AssignmentEditSettings: [],
    AllDealersCountryCodes: [],
  };
}

const state = initialLoad();

const getters = {
  AssignmentEditSettings: state => state.AssignmentEditSettings,
  AMDealerSettings: state => state.AMDealerSettings,
  getPlatformInfo: state => platformId => {
    // Used primarily to check for country
    if (state.PlatformInfo && state.PlatformInfo.length > 0) {
      return state.PlatformInfo.find(platform => {
        return platform.AccountPlatformID == platformId;
      });
    }
  },
  DealerSettings: state => state.DealerSettings,
  BdcStores() {
    if (state.DealerSettings && state.DealerSettings.length > 0) {
      return state.DealerSettings.filter(ds => {
        return ds.IsBdcEnabled;
      });
    }
    return [];
  }
};

const actions = {
  loadAMDealerSetting: function (context, dealerId) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "GET",
          "/api/dealer_settings/dealer_setting_all/" + dealerId
        )
        .then(function (data) {
          if (data && data.data && data.data.data) {
            context.commit("updateAMDealerSettings", data.data.data);
            resolve(data.data.data);
          } else {
            reject(null);
          }
        })
        .catch(error => reject(error));
    });
  },
  getDealerSettings: function (context, request) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/api/dealer_settings/get_account_platform_settings",
          request
        )
        .then(function (data) {
          if (data && data.data && data.data.successful) {
            resolve(data.data.data);
          } else {
            reject(null);
          }
        })
        .catch(error => reject(error));
    });
  },
  saveDealerSettings: function (context, request) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/api/dealer_settings/save_account_platform_settings",
          request
        )
        .then(function (data) {
          if (data && data.data && data.data.data) {
            resolve(data.data.data);
          } else {
            reject(null);
          }
        })
        .catch(error => reject(error));
    });
  },
  // get1PlatformInfo: function(context, accountPlatformId) {
  //   return new Promise((resolve, reject) => {
  //     Vue.http
  //       .get("/platform/" + accountPlatformId)
  //       .then(resp => {
  //         if (!resp.data || !resp.data.Data) reject(resp);
  //         else {
  //           resolve(resp.data.Data);
  //         }
  //       })
  //       .catch(resp => {
  //         reject(resp);
  //       });
  //   });
  // },
  getAllPlatformInfo: async function (context) {
    // DO NOT USE TO POPULATE STORE DROPDOWNS
    // Used primarily to check for country
    const response = await Vue.http.get(`/account/platforms/${context.getters.User.ViewAccountID}`).catch(err => err.response);
    if (response && response.data && response.data.Success) {
      context.commit("saveAllPlatformInfo", response.data.Data);
    }
  },
  loadDealerSettings: function (context) {
    return new Promise((resolve, reject) => {
      const _AccountPlatformIds = context.getters.CXMStores.map(
        store => store.AccountPlatformID
      );
      if (!_AccountPlatformIds || _AccountPlatformIds.length <= 0) {
        reject();
        return;
      }
      Vue.http
        .post("/pando/dealersettings/dealers_settings_list", {
          AccountPlatformIds: _AccountPlatformIds
        })
        .then(function (data) {
          if (data && data.data && data.data.Data) {
            const Data = data.data.Data;
            context.commit("updateDealerSettings", Data);
            resolve(Data);
          } else {
            reject();
          }
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  async getCalendarSettings(context, request) {
    let cxmApiClient = new CXMApiClient();
    let response = await cxmApiClient.ProcessRequest(
      "POST",
      "/api/dealer_settings/UI_Dealer_settings/get",
      request
    );
    return response && response.data && response.data.data
      ? response.data.data
      : null;
  },
  async getAssignmentEditSettings(context, request) {
    if (request) {
      let cxmApiClient = new CXMApiClient();
      let response = await cxmApiClient
        .ProcessRequest(
          "get",
          "/api/edit_contact_user_assignments/dealer_settings/" +
          request +
          "/get_contact_user_assignment_dealer_settings"
        )
        .catch(err => err.response);
      context.commit("updateAssignmentEditSettings", response.data.data);
      return response.data.data;
    } else {
      return null;
    }
  },
  async getAllDealerCountryCodes(context, platformIds) {
    let response = await Vue.http.post("/platform/getMultiple", platformIds);
    if (response)
      context.commit(
        "updatePlatformCountryDetails",
        response.data ? response.data.Data : []
      );
  }
};

const mutations = {
  saveAllPlatformInfo: function (state, data) {
    state.PlatformInfo = data || [];
  },
  updateAssignmentEditSettings: function (state, data) {
    state.AssignmentEditSettings.push(data);
  },
  updateAMDealerSettings: function (state, data) {
    state.AMDealerSettings.push(data);
  },
  updateDealerSettings: function (state, data) {
    data.forEach(setting => {
      if (setting && setting.NotificationRules) {
        setting.NotificationRules.forEach(rule => {
          rule.Role = null;
          rule.selected_users = null;
          rule.Group = null;
          rule.EventTypeSelected = null;
        });
      }

      if (setting && setting.ReassignRules) {
        setting.ReassignRules.forEach(rule => {
          rule.Role = null;
          rule.selected_user = null;
          rule.Group = null;
          rule.EventTypeSelected = null;
          rule.SelectedAction = null;
        });
      }
    });
    state.DealerSettings = data;
  },
  updatePlatformCountryDetails: function (state, data) {
    let platformLite = data.map(x => ({
      accountPlatformId: x.AccountPlatformID,
      countryId: x.CountryID,
      dealerId: x.AutoAlertDealerID
    }));
    state.AllDealersCountryCodes = platformLite;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/DealerSettings.js